import { Notification } from 'element-ui';
import store from '@/store';

export const smsCampaignFeatureGuard = async (to, from, next) => {
  try {
    // check to see if company has access to feature, if so continue, else redirect to block page
    await store.dispatch('smsCampaign/getCompanySettings');
    if (
      store.getters['smsCampaign/campaignsFeatureIsSetup']
      && store.getters['smsCampaign/campaignsFeatureIsActive']
    ) {
      next();
    } else {
      next({
        name: 'SMS campaigns / Setup',
      });
    }
  } catch (error) {
    Notification({
      type: 'error',
      title: 'Error',
      message: 'Error loading sms campaign feature.',
    });
  }
};

export const smsCampaignBlockPageGuard = async (to, from, next) => {
  try {
    // check to see if company has access to feature, if so redirect to feature, else continue
    await store.dispatch('smsCampaign/getCompanySettings');
    if (
      store.getters['smsCampaign/campaignsFeatureIsSetup']
      && store.getters['smsCampaign/campaignsFeatureIsActive']
    ) {
      next({
        name: 'SMS campaigns',
      });
    } else {
      next();
    }
  } catch (error) {
    Notification({
      type: 'error',
      title: 'Error',
      message: 'Error loading sms campaign feature.',
    });
  }
};
